/**
 * Header: mobile menu toggle, search toggle, scroll hide/show navbar.
 * window.toggleHeaderMenu is exposed so .menu-icon click handlers can call it.
 * window.disableHeaderAnim is set in finalize and read by the scroll handler here.
 */

function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}

function enableBodyScroll() {
  document.body.style.overflow = '';
}

function toggleHeaderMenu() {
  $('body > nav.site-navigation').toggleClass('-is-active');
  $('body > nav.site-navigation .site-menu-container').toggleClass('d-none');
  $('body > nav.site-navigation .search-form-container').addClass('d-none');
  $('.search-icon').toggleClass('d-none');
  $('body > header.mobile-header').toggleClass('-is-active');
  $('body > header.site-header:not(.-has-club-light-bg)').removeClass('hide-nav').addClass('show-nav');

  if ($('body > nav.site-navigation').hasClass('-is-active')) {
    disableBodyScroll();
  } else {
    enableBodyScroll();
  }
}

function initMenuToggle() {
  $(document).on('click', '.menu-icon', function() {
    $(this).toggleClass('-is-active');
    window.toggleHeaderMenu();
  });

  $(document).on('click', '.search-icon', function() {
    $(this).toggleClass('-is-active');
    $('body > nav.site-navigation').toggleClass('-is-active');
    $('body > nav.site-navigation .site-menu-container').addClass('d-none');
    $('body > nav.site-navigation .search-form-container').toggleClass('d-none');
    $('.menu-icon').toggleClass('d-none');
    $('body > header.mobile-header').toggleClass('-is-active');
    $('.site-navigation').find('.social').closest('div').toggleClass('d-none');
    $('body > header.site-header:not(.-has-club-light-bg)').removeClass('hide-nav').addClass('show-nav');

    if ($(this).hasClass('-is-active')) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  });

  // Sub-menu expand
  $('.menu-item-has-children .prime-icon').click(function(e) {
    e.stopPropagation();
    $(this).closest('.menu-item-has-children').toggleClass('-is-expanded');
  });

  $('.menu-item-has-children.-is-trigger-only').click(function(e) {
    e.stopPropagation();
    $(this).toggleClass('-is-expanded');
  });
}

function initScrollBehaviour() {
  let c = 0;
  let currentScrollTop = 0;

  $(window).scroll(function() {
    window.iTheHeight = $(window).height()
      || window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;

    const st = $(this).scrollTop();
    window.lastScrollTop = st;

    // Archive article reveal on scroll
    if ($('.single-archive-article').length > 0) {
      $('.single-archive-article').each(function() {
        if (window.isInViewport($(this), $(window))) {
          if (window.iTheCurrentSiteID === 0 || window.iTheCurrentSiteID === $(this).attr('data-site-id') * 1) {
            $(this).addClass('-is-visible').removeClass('-is-hidden');
          }
        }
      });
    }

    const navbar = $('body > header.site-header:not(.-has-club-light-bg)');
    const a      = $(window).scrollTop();
    const b      = navbar.height();
    currentScrollTop = a;

    if (window.disableHeaderAnim === false) {
      const isHomepage = $('body.team.home').length > 0 || $('body.nth.home').length > 0;
      const hasHero    = $('.single-match-info').length > 0 || $('.prime-matches-horizontal').length > 0;

      if (isHomepage && hasHero && $('.hero-content').length > 0) {
        let top;
        if ($('body.nth.home').length > 0) {
          const mTop = parseInt($('.prime-match-slider-outer').css('margin-top'), 10);
          top = $('.prime-match-slider-outer').outerHeight() + mTop + mTop;
        }
        if ($('body.team.home').length > 0) {
          top = $('.single-match-info').outerHeight() * 1.5;
        }

        if (st > top) {
          if (c < currentScrollTop && a > b + b) {
            navbar.addClass('hide-nav').removeClass('show-nav');
          } else if (c > currentScrollTop && !(a <= b)) {
            navbar.removeClass('hide-nav').addClass('show-nav');
          }
        }
      } else {
        if (c < currentScrollTop && a > b + b) {
          navbar.addClass('hide-nav').removeClass('show-nav');
        } else if (c > currentScrollTop && !(a <= b)) {
          navbar.removeClass('hide-nav').addClass('show-nav');
        }
      }
    } else {
      if (currentScrollTop > 100) {
        navbar.addClass('hide-nav').removeClass('show-nav');
      } else {
        navbar.removeClass('hide-nav').addClass('show-nav');
      }
    }

    // Stats table sticky header
    if ($('.prime-stats-table').length > 0) {
      $('.prime-stats-table').each(function() {
        const $table     = $(this);
        const $container = $table.closest('.prime-stats-table-container');

        if (window.isTopAboveViewportTop($table, $(window)) && !window.isBottomAboveViewportTop($table, $(window)) && !$container.hasClass('-lock-to-viewport')) {

          const iTheRowWidth = $table.find('thead tr').outerWidth();
          $table.find('thead tr th').each(function() {
            $(this).css({ width: $(this).outerWidth() + 'px' }).attr('data-width', $(this).outerWidth());
          });

          $container.addClass('-lock-to-viewport');
          $table.find('thead > tr').clone().addClass('-is-spacer-row').insertAfter(
            $table.find('thead > tr').css('width', iTheRowWidth + 'px')
          );

          let iTheTW = 0;
          $table.find('.tablesorter-headerRow:not(.-is-spacer-row) th').each(function(i) {
            const iTheW = $('.tablesorter-headerRow.-is-spacer-row th').eq(i).outerWidth();
            $(this).css({ width: iTheW + 'px' });
            iTheTW += iTheW;
          });
          $table.find('.tablesorter-headerRow:not(.-is-spacer-row)').css({ width: iTheTW + 'px' });

          window.disableHeaderAnim = true;

        } else if ((window.isBottomAboveViewportTop($table, $(window)) && $container.hasClass('-lock-to-viewport'))
          || (!window.isTopAboveViewportTop($table, $(window)) && $container.hasClass('-lock-to-viewport'))) {

          $container.removeClass('-lock-to-viewport');
          $table.find('.-is-spacer-row').remove();
          $table.find('.tablesorter-headerRow').css('transform', 'none');
          $table.find('.tablesorter-headerRow .player-main').css('transform', 'none');

          window.disableHeaderAnim = false;
        }
      });
    }

    c = currentScrollTop;
  });
}

export function initHeader() {
  window.disableHeaderAnim = false;
  window.toggleHeaderMenu  = toggleHeaderMenu;

  initMenuToggle();
  initScrollBehaviour();
}



// WEBPACK FOOTER //
// ./scripts/routes/common/header.js